var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApproveRateperformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.765,
    height: 80,
    viewBox: "0 0 52.765 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approve_Rate_performance",
    "data-name": "Approve & Rate performance",
    transform: "translate(-38.292 -18.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M81.718,56.778l-6.457-1.3L81.08,25.54H49.289l5.819,29.933-6.457,1.3L41.2,18.8H89.169Z",
    transform: "translate(-0.8)",
    fill: "#f48a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_1_",
    transform: "translate(38.292 28.947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    d: "M48.749,74.56l6.683,6.523a3.192,3.192,0,0,1,.924,2.907l-1.564,9.217,8.247-4.325a3.472,3.472,0,0,1,3.128,0l8.247,4.325-1.493-9.217a3.135,3.135,0,0,1,.924-2.907l6.683-6.523-9.242-1.347A3.2,3.2,0,0,1,68.8,71.369L64.674,63,60.55,71.369a3.493,3.493,0,0,1-2.488,1.843Zm1.635,28.005a3.491,3.491,0,0,1-1.991-.638,3.364,3.364,0,0,1-1.351-3.261L49.46,84.556,39.293,74.631a3.34,3.34,0,0,1-.853-3.4,3.415,3.415,0,0,1,2.7-2.269L55.36,66.9,61.688,54.07a3.34,3.34,0,0,1,5.972,0L73.987,66.9l14.219,2.056a3.415,3.415,0,0,1,2.7,2.269,3.34,3.34,0,0,1-.853,3.4l-10.309,10,2.417,14.109a3.369,3.369,0,0,1-4.834,3.545L64.6,95.617l-12.726,6.665A3.305,3.305,0,0,1,50.384,102.565ZM61.048,46.129V32.8h6.683V46.129Z",
    transform: "translate(-38.292 -32.8)",
    fill: "#12355f",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveRateperformance);
export default __webpack_public_path__ + "static/media/Approve & Rate performance.8ab8b08232babc8c01d8fde3142129e4.svg";
export { ForwardRef as ReactComponent };